/* eslint-disable react/prop-types */
import { withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { ExpansionPanel } from '../../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../../styles/styles';
import { FormDetails } from '../../form-details-reducer';
import { EmploymentHistoryView } from '../../details/employmentHistoryView';
import { IncomeHistoryView } from '../../details/incomeHistoryView';
import { EmploymentView } from '../../details/employment';

interface BaseProps {
    formDetails?: FormDetails;
    disableEditButton?: boolean;
}

interface Props extends StyledComponent, BaseProps {}

const employmentGroupView: React.FunctionComponent<Props> = ({
    formDetails,
    disableEditButton,
}) => {
    return (
        <ExpansionPanel name="Employment Details" style={{ marginLeft: -24, marginRight: -24 }}>
            <React.Fragment>
                <EmploymentView formDetails={formDetails} disableEditButton={true} />
                <EmploymentHistoryView
                    formDetails={formDetails}
                    disableEditButton={disableEditButton}
                />
                <IncomeHistoryView
                    formDetails={formDetails}
                    disableEditButton={disableEditButton}
                />
            </React.Fragment>
        </ExpansionPanel>
    );
};

export const EmploymentGroupView = withStyles(styles)(employmentGroupView);
